import { render, staticRenderFns } from "./comparison-working.vue?vue&type=template&id=7c8d8e52"
import script from "./comparison-working.vue?vue&type=script&lang=js"
export * from "./comparison-working.vue?vue&type=script&lang=js"
import style0 from "./comparison-working.vue?vue&type=style&index=0&id=7c8d8e52&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports